import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import * as discussionActions from '../../actions/discussionActions';
import { Modal, Button, Paragraph } from '@netexknowledge/smart-components';

class CloseDiscussionReveal extends Component {
  static propTypes = {
    discussion: PropTypes.object.isRequired,
    discussionActions: PropTypes.object.isRequired
  };

  onCloseTopic = () => {
    const { discussionActions, discussion } = this.props;
    discussionActions.closeDiscussion(discussion.id);
    this.closeModal();
  };

  closeModal = () => {
    const { discussionActions } = this.props;
    discussionActions.setCloseDiscussionRevealOpen(false);
    discussionActions.setCloseDiscussionRevealData();
  };

  render() {
    const { discussion } = this.props;

    return (
      <Modal
        id="close-discussion"
        title={I18n.t('discussions.modal.closeDiscussionTitle')}
        active
        onClickOutside={this.closeModal}
        children={
          <Paragraph className="text-grey-700">
            {I18n.t('discussions.modal.closeDiscussionBody', { discussionName: discussion.title })}
          </Paragraph>
        }
        footer={
          <>
            <Button onClick={this.closeModal} label={I18n.t('common.cancel')}></Button>
            <Button
              onClick={this.onCloseTopic}
              primary
              label={I18n.t('discussions.modal.closeDiscussionButton')}
            ></Button>
          </>
        }
      ></Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    discussion: state.discussions.closeReveal.discussion
  };
}

function mapDispatchToProps(dispatch) {
  return {
    discussionActions: bindActionCreators(discussionActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CloseDiscussionReveal);
